import React from 'react';
import './respostaTexto.css';

const RespostaTexto = ({
  respostas,
  editable = false,
  valor = '',
  onChange,
  onBlur,
  showSave = false,
  onSave,
  isSaving = false,
  maxLength = 500,
}) => {
  if (editable) {
    return (
      <div className="resp-texto">
        <span className="resp-label">Resposta:</span>
        <textarea
          value={valor}
          onChange={(event) => onChange?.(event.target.value)}
          onBlur={() => onBlur?.()}
          placeholder="Digite sua resposta..."
          maxLength={maxLength}
        />
        <div className="resp-datas">
          <small>
            {valor.length}/{maxLength}
          </small>
          {showSave && (
            <button
              type="button"
              className="resp-save-btn"
              onClick={() => onSave?.()}
              disabled={isSaving}
            >
              Salvar
            </button>
          )}
        </div>
      </div>
    );
  }

  const resposta = respostas?.[0];
  const texto = resposta?.resposta?.trim();

  if (!texto) {
    return (
      <div className="resp-texto vazio">
        <span className="resp-label">Resposta:</span>
        <em className="texto-pendente">Sem resposta</em>
      </div>
    );
  }

  return (
    <div className="resp-texto">
      <span className="resp-label">Resposta:</span>

      <div className="texto-conteudo">{texto}</div>

      {/* <div className="resp-datas">
        <small>última atualização: {resposta.dataUltimaResposta}</small>
      </div> */}
    </div>
  );
};

export default RespostaTexto;
